function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Spinner } from "@neru/ui";
import * as R from "ramda";
import { lazy, memo, Suspense, useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import { useDialogs } from "../../hooks";
import { Emitter } from "../../services";
import { DIALOG_TYPES } from "../../types";
import { componentLoader } from "../../utils";
var useAppSelector = useSelector;
var importConfirmDialog = function() {
    return /*#__PURE__*/ lazy(function() {
        return componentLoader(function() {
            return import("./ConfirmDialog");
        });
    });
};
var importFormDialog = function(id) {
    var _id_split = _sliced_to_array(id.split("/"), 2), featureName = _id_split[0], dialogComponent = _id_split[1];
    return /*#__PURE__*/ lazy(function() {
        return componentLoader(function() {
            return import("../../features/".concat(featureName, "/dialogs/").concat(dialogComponent, "Dialog"));
        });
    });
};
var getDialogBody = function(_param) {
    var id = _param.id, dialog = _object_without_properties(_param, [
        "id"
    ]);
    switch(dialog.type){
        case DIALOG_TYPES.confirm:
            {
                var ConfirmBody = importConfirmDialog();
                return /*#__PURE__*/ _jsx(ConfirmBody, _object_spread_props(_object_spread({}, dialog.props), {
                    id: id,
                    onSubmit: handleSubmit(id)
                }));
            }
        case DIALOG_TYPES.form:
            {
                var FormBody = importFormDialog(id);
                return /*#__PURE__*/ _jsx(FormBody, _object_spread_props(_object_spread({}, dialog.props), {
                    id: id,
                    onSubmit: handleSubmit(id)
                }));
            }
    }
};
var handleSubmit = R.curry(function(id, data) {
    Emitter.emit(id, data);
});
var Dialogs = /*#__PURE__*/ memo(function(param) {
    var dialogs = param.dialogs;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: dialogs.map(function(dialog) {
            return /*#__PURE__*/ _jsx(Suspense, {
                fallback: /*#__PURE__*/ _jsx(Spinner, {}),
                children: getDialogBody(dialog)
            }, dialog.id);
        })
    });
});
export var DialogsStack = function() {
    var _useAppSelector = useAppSelector(function(param) {
        var collection = param.dialogs;
        return collection;
    }), childDialogs = _useAppSelector.childDialogs, confirmDialogs = _useAppSelector.confirmDialogs, dialogs = _useAppSelector.dialogs;
    var closeDialog = useDialogs().closeDialog;
    var handleKeyDown = useCallback(function(e) {
        var lastDialog;
        if (confirmDialogs.length > 0) {
            lastDialog = confirmDialogs[confirmDialogs.length - 1];
        } else if (childDialogs.length > 0) {
            lastDialog = childDialogs[childDialogs.length - 1];
        } else if (dialogs.length > 0) {
            lastDialog = dialogs[dialogs.length - 1];
        }
        if (e.key === "Escape" && lastDialog) {
            closeDialog(lastDialog.id);
        }
    }, [
        childDialogs,
        closeDialog,
        confirmDialogs,
        dialogs
    ]);
    var handleBackNavigation = useCallback(function() {
        if (location.href.includes("#")) return;
        _to_consumable_array(confirmDialogs).concat(_to_consumable_array(childDialogs), _to_consumable_array(dialogs)).forEach(function(param) {
            var id = param.id;
            return closeDialog(id);
        });
    }, [
        childDialogs,
        closeDialog,
        confirmDialogs,
        dialogs
    ]);
    useEffect(function() {
        document.addEventListener("keydown", handleKeyDown);
        window.addEventListener("popstate", handleBackNavigation);
        return function() {
            document.removeEventListener("keydown", handleKeyDown);
            window.removeEventListener("popstate", handleBackNavigation);
        };
    }, [
        handleBackNavigation,
        handleKeyDown
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Dialogs, {
                dialogs: dialogs
            }),
            /*#__PURE__*/ _jsx(Dialogs, {
                dialogs: childDialogs
            }),
            /*#__PURE__*/ _jsx(Dialogs, {
                dialogs: confirmDialogs
            })
        ]
    });
};

//# sourceMappingURL=DialogsStack.js.map